module.exports = __webpack_public_path__ + "static/block-bea0d159d04c08f15e3d96713926bc76.png";